<template>
  <div class="fill-height">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-row 
            align="center" 
            justify="center"
            style="height: 100vh;">
            <v-col v-if="rps === 'lg'"
              cols="12" 
              md="8" 
              sm="6"
              class="py-0">
              <v-img 
                width="100%"
                height="100vh"
                alt="umb" 
                gradient="to top, rgba(35, 145, 208, .75), rgba(0, 0, 0, 0) calc(100% - 250px)"
                :src="require('@/assets/background/basic_bg.jpg')"
                class="ma-auto">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#2391d0">
                    </v-progress-circular>
                  </v-row>
                </template>

                <div
                  style="position: absolute; bottom: 25px; left: 40px;">
                  <div
                    class="body-2 white--text">
                    Copyright@{{ new Date().getFullYear() }} <strong>sitr.klaten.go.id</strong>
                  </div>
                </div>
              </v-img>
            </v-col>

            <v-col 
              cols="12" 
              md="4" 
              sm="6">
              <v-card
                flat
                color="transparent"
                :class="rps === 'lg' ? 'px-16' : 'px-6'">
                <div
                  :class="rps === 'lg' ? 'pr-8' : ''">
                  <div
                    class="pb-12 mb-12">
                    <v-img 
                      contain
                      width="250"
                      height="250"
                      alt="umb" 
                      :src="require('@/assets/logo/favicon.png')"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="#2391d0">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <div
                      class="text-h4 font-weight-bold text-center color-default">
                      Kabupaten Klaten
                    </div>
                  </div>

                  <div>
                    <div
                      class="mb-6">
                      <div
                        class="title color-default font-weight-bold mb-2">
                        Masuk
                      </div>

                      <div
                        class="body-2 line-text-first"
                        style="opacity: 60%;">
                        Silahkan masuk menggunakan username yang telah terdaftar.
                      </div>
                    </div>

                    <ValidationObserver 
                      ref="observer">
                      <v-form class="text-left mb-6">
                        <ValidationProvider 
                          name="username" 
                          rules="required" 
                          v-slot="{ errors }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            class="no_box"
                            solo
                            color="#2391d0"
                            placeholder="Username"
                            prepend-inner-icon="mdi-account-outline"

                            v-model="form.username"
                            :error-messages="errors"
                            required>
                          </v-text-field>
                        </ValidationProvider>

                        <ValidationProvider 
                          name="password" 
                          rules="required|min:5|max:20" 
                          v-slot="{ errors }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            class="no_box"
                            solo
                            color="#2391d0"
                            placeholder="Password"
                            :type="show ? 'text' : 'password'"
                            prepend-inner-icon="mdi-lock-outline"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="show = !show"
                            :counter="20"
                            
                            v-model="form.password"
                            :error-messages="errors"
                            required>
                          </v-text-field>
                        </ValidationProvider>
                      </v-form>
                    </ValidationObserver>

                    <div 
                      class="text-center mb-6">
                      <v-alert 
                        type="error" 
                        text 
                        dense 
                        prominent 
                        v-show="message.error !== ''"
                        v-html="message.error">
                      </v-alert>

                      <v-btn
                        v-on:keyup.enter="save"
                        :disabled="process.form"
                        :loading="process.form"
                        @click="save"
                        block
                        x-large
                        width="170"
                        elevation="0"
                        class="title font-weight-bold white--text text-capitalize btn_auth"
                        style="border-radius: 10px;">
                        <div
                          class="btn_auth_in">
                          Masuk
                        </div>
                      </v-btn>
                    </div>

                    <div
                      class="body-2 text-center"
                      style="opacity: 60%;">
                      Lupa password
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          fcm: ''
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    methods: {
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('auth/admin/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.code === 200) {
              let user = res.data,
                  menu = [
                    {
                      title: 'Dashboard',
                      icon: 'mdi-view-dashboard-outline',
                      link: '/dashboard',
                      active: true,
                      sub_menu: []
                    },
                    {
                      title: 'Layanan',
                      icon: 'mdi-newspaper-variant-multiple-outline',
                      link: '/service',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Data Layanan',
                          link: '/service',
                          active: false
                        },
                        {
                          title: 'Data Ajuan',
                          link: '/service/submission',
                          active: false
                        }
                      ]
                    },
                    {
                      title: 'Pengguna',
                      icon: 'mdi-account-supervisor-outline',
                      link: '/user',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Kategori',
                      icon: 'mdi-tag-multiple-outline',
                      link: '/category',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Berita',
                      icon: 'mdi-newspaper',
                      link: '/news',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Pengumuman',
                      icon: 'mdi-bullhorn-variant-outline',
                      link: '/announcement',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Konfigurasi',
                      icon: 'mdi-cog-outline',
                      link: '/setting',
                      active: false,
                      sub_menu: []
                    }
                  ]

              TokenService.saveToken(
                res.data.token,
                JSON.stringify(user),
                JSON.stringify(menu)
              )

              TokenService.saveReload(false)
              
              window.location = `${process.env.BASE_URL}dashboard`
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>